<template>
    <div class="contact-switch-screen">
        <md-progress-bar md-mode="indeterminate" v-if="loading" />
        <div class="toolbar">
            <span class="title">{{ $t("chatWindow.systemStatus") }}</span>
            <div class="actions">
                <SupsisButton ghost @click="refresh">
                    <div class="btn-refresh" @click="refresh">
                        <span class="shortcut-keyboard"> R </span>
                        <i class="material-icons">refresh</i>
                        {{ $t("chatWindow.refresh") }}
                    </div>
                </SupsisButton>
                <SupsisButton primary @click="close">
                    <i class="material-icons">close</i>
                    {{ $t("chatWindow.close") }}
                </SupsisButton>
            </div>
        </div>

        <div class="summary">
            <div class="item">
                <span class="key">{{ $t("chatWindow.totalCustomers") }}</span>
                <span class="value">{{ getSummary().totalCustomers }}</span>
            </div>
            <div class="item">
                <span class="key">{{ $t("chatWindow.totalAnswered") }}</span>
                <span class="value">{{ getSummary().totalAnswered }}</span>
            </div>
            <div class="item">
                <span class="key">{{ $t("chatWindow.waitingAnswer") }}</span>
                <span class="value">{{ getSummary().waitingAnswer }}</span>
            </div>
            <div class="item">
                <span class="key">{{ $t("chatWindow.totalAgentInChat") }}</span>
                <span class="value">{{ getSummary().totalAgentInChat }}</span>
            </div>
            <div class="item">
                <span class="key">{{ $t("chatWindow.onlineAgentCount") }}</span>
                <span class="value">{{ getSummary().onlineAgentCount }}</span>
            </div>
        </div>
        <a-divider />
        <div class="agent-filters">
            Filter By
            <CircleUserSelect :users="getOnlineUsers()" :value="selectedUserId" @input="changeAgentFilter" nullable />
        </div>
        <a-divider />

        <div class="groups mt-2">
            <div
                v-for="group in $_.orderBy(getGroups(), 'order').map((x) => x.id)"
                :key="group"
                class="group"
                v-if="isVisibleGroup(getGroups()[group])"
            >
                <div class="group-header">
                    <AgentAvatar
                        :key="getGroups()[group].id"
                        :size="50"
                        :font-size="15"
                        :userID="getGroups()[group].id"
                        v-if="getGroups()[group].id"
                    />
                    <h2>{{ agentName(getGroups()[group].id) }}</h2>
                    <div class="group-stats">
                        <i class="material-icons">star</i>
                        <div class="group-stats-item total">
                            <span class="key">{{ $t("chatWindow.totalCustomer") }}</span>
                            <span class="value">{{ getGroupStats(getGroups()[group]).totalCustomers }}</span>
                        </div>
                        <i class="material-icons">star</i>
                        <div class="group-stats-item answered">
                            <span class="key"> {{ $t("chatWindow.answered") }}</span>
                            <span class="value">{{ getGroupStats(getGroups()[group]).answered }}</span>
                        </div>
                        <i class="material-icons">star</i>
                        <div class="group-stats-item unanswered">
                            <span class="key">{{ $t("chatWindow.unanswered") }}</span>
                            <span class="value">{{ getGroupStats(getGroups()[group]).unanswered }}</span>
                        </div>
                        <SupsisButton ghost @click="() => watchAll(getGroups()[group].id)">
                            Tümünü Canlı İzle
                        </SupsisButton>
                    </div>
                </div>
                <div class="customers">
                    <div
                        v-for="item in getGroups()[group].items"
                        :key="item.name"
                        class="customer-card"
                        :class="{ selected: selectedIndex === item.index }"
                        @click="() => selectWithIndex(item.index)"
                        :data-index="item.index"
                    >
                        <span class="index-shortcut-keyboard" v-if="item.index < 9">{{ item.index + 1 }}</span>

                        <div class="customer-info">
                            <div class="first-line">
                                <i class="material-icons">person</i>
                                <div class="texts">
                                    <div class="customer-name">{{ item.visitor.fullname }}</div>
                                    <div class="customer-agent">
                                        {{ $t("chatWindow.agent") }}:
                                        {{ agentName(getGroups()[group].id) }}
                                    </div>
                                </div>
                            </div>

                            <div class="metas">
                                <div
                                    class="customer-duration"
                                    :key="`${dateRenderKey}-${getGroups()[group].agent}-${item._id}`"
                                >
                                    <i class="material-icons">timer</i>
                                    {{ fromNow(item.createdDate) }}
                                </div>
                                <div
                                    class="customer-status"
                                    :class="{
                                        answered: item.answerStatus === 'answered',
                                        waiting: item.answerStatus !== 'answered',
                                    }"
                                >
                                    {{ item.answerStatus === "answered" ? "Answered" : "Waiting Answer" }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import { getChatsOverview } from "../../../api/chat";
import log2 from "../../../utils/log2";
import _ from "lodash";
import moment from "moment/moment";
import AgentAvatar from "../../common/AgentAvatar.vue";
import SupsisButton from "../../../views/Pages/Settings/components/SupsisButton.vue";
import StringUtils from "../../../utils/StringUtils";
import CircleUserSelect from "./multi-chat-viewer/CircleUserSelect.vue";
import { USER_API } from "../../../api/user";

const log = log2("ContactSwitchScreen");
const createChat = () => {
    return {
        _id: "66ca105a8e7814a4b7b83395" + Math.floor(Math.random() * 100),
        users: [["5d14ee322d95ad001ebdf214"], ["666b18735e02b136d9ac0c94"], []][Math.floor(Math.random() * 3)],
        status: ["active", "chatbot", "new"][Math.floor(Math.random() * 3)],
        answerStatus: ["unanswered", "answered"][Math.floor(Math.random() * 2)],
        createdDate: moment()
            .subtract(Math.floor(Math.random() * 1000 * 60), "ms")
            .toISOString(),
        visitor: {
            _id: "66c5d57d35dfd9fc8422aeec" + Math.floor(Math.random() * 100),
            fullname: "Fatih Bey " + Math.floor(Math.random() * 100),
        },
        connectedUser: ["5d14ee322d95ad001ebdf214", "666b18735e02b136d9ac0c94", null][Math.floor(Math.random() * 3)],
    };
};
const mockChats = () => _.times(40, createChat);
export default Vue.extend({
    name: "ContactSwitchScreen",
    components: { CircleUserSelect, SupsisButton, AgentAvatar },
    props: {
        toggleConversation: {
            type: Function,
            default: _.noop,
        },
    },
    computed: {
        ...mapState({
            contactListSortMode: (state) => state.chat.contactListSortMode,
            contacts: (state) => state.chat.contactLists,
            usersOrdered: (state) => _.orderBy(state.user.users.data, ["name", "status"], ["desc", "asc"]),
            users: (state) =>
                state.user.users.data.reduce((acc, user) => {
                    acc[user._id] = user;
                    return acc;
                }, {}),
            user: (state) => state.auth.user,
            watchingContactIds: (state) => state.chat.watchingContactIds,
            activeContact: (state) => state.chat.activeContact,
            multiChatViewerMode: (state) => state.chat.multiChatViewerMode,
            stats: (state) => state.chat.stats,
        }),
    },
    data() {
        return {
            summary: {
                totalCustomers: 10,
                totalInChat: 8,
                totalAnswered: 6,
                waitingAnswer: 2,
            },
            chats: [],
            loading: false,
            dateRenderKey: 0,
            dateInterval: null,
            selectedIndex: 0,
            total: 0,
            cache: null,
            cacheKey: "",
            first: true,
            initialized: false,
            selectedUserId: null,
            onlineUsers: [],
        };
    },
    methods: {
        ...mapActions({
            watchContactConversation: "chat/watchContactConversation",
            getContactById: "chat/getContactById",
            unWatchContactConversation: "chat/unWatchContactConversation",
            setMultiChatViewerMode: "chat/setMultiChatViewerMode",
        }),
        isVisibleGroup(group) {
            if (this.selectedUserId === null) return true;
            return group.id === this.selectedUserId;
        },
        changeAgentFilter(userId) {
            log("changeAgentGroup", userId);
            this.selectedUserId = userId;
        },
        fetchOnlineUsers() {
            USER_API.getOnlineUsers(["_id,name,status"], true, false).then((users) => {
                this.onlineUsers = users;
            });
        },
        getOnlineUsers() {
            const { usersChatCounts } = this.stats;
            return this.onlineUsers.map((user) => {
                return {
                    user,
                    badge: usersChatCounts[user._id] || 0,
                };
            });
        },
        // getGroupOrderedAsArray() {
        //     let index = 0;
        //     const groups = this.getGroups();
        //     const result = Object.keys(groups)
        //         .sort((a, b) => {
        //             return groups[a].order - groups[b].order;
        //         })
        //         .reduce((acc, key) => {
        //             groups[key].items.forEach((item) => {
        //                 item.index = index++;
        //             });
        //             acc.push(groups[key]);
        //             return acc;
        //         }, []);
        //     this.total = index;
        //     return result;
        // },
        watchAll(id) {
            console.log("watchAll", id);
            const idMap = {
                unassign: "queue",
            };
            this.setMultiChatViewerMode({
                enabled: true,
                value: idMap[id] || id,
                type: "agent",
            });
        },
        close() {
            this.$emit("close");
        },
        getSummary() {
            const groups = this.getGroups();
            const agentCount = Object.keys(groups).filter((key) => key !== "null" && !!key).length;
            return {
                totalCustomers: this.chats.length,
                totalAgentInChat: agentCount,
                totalAnswered: this.chats.filter((item) => item.answerStatus === "answered").length,
                waitingAnswer: this.chats.filter((item) => item.answerStatus !== "answered").length,
                onlineAgentCount: Object.values(this.users).filter((user) => user.isOnline && user.status === "Online")
                    .length,
            };
        },
        getGroupStats(group) {
            return {
                totalCustomers: group.items.length,
                answered: group.items.filter((item) => item.answerStatus === "answered").length,
                unanswered: group.items.filter((item) => item.answerStatus !== "answered").length,
                autoAssignLimit: this.users[group.id]?.autoAssignLimit || 0,
            };
        },
        fromNow(date) {
            const createdDate = moment(date);
            const duration = moment.duration(moment().diff(createdDate));

            if (duration >= 1000 * 60 * 60) {
                return moment.utc(duration.asMilliseconds()).format("HH:mm:ss");
            } else {
                return moment.utc(duration.asMilliseconds()).format("mm:ss");
            }
        },
        fetchChats(e, first) {
            log("fetchChats");
            if (e) e.stopPropagation();
            this.loading = true;

            getChatsOverview()
                .then((items) => {
                    this.selectedIndex = 0;
                    this.total = 0;
                    this.initialized = true;
                    this.chats = items;
                    // this.chats = mockChats();
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        findIndexByContactId(groups, contactId) {
            const flatItems = Object.keys(groups)
                .map((x) => groups[x].items)
                .flat();
            const selectedIndex = flatItems.find((item) => item.visitor?._id === contactId)?.index;
            log("findIndexByContactId", { selectedIndex, contactId, flatItems, groups: groups });
            return selectedIndex || 0;
        },
        getGroups(by = "agent") {
            const cacheKey = StringUtils.hashCodeObj(this.chats);
            if (this.cacheKey === cacheKey && this.cache) {
                return this.cache;
            }
            log("getGroups");
            let index = 0;
            const result = this.chats.reduce((acc, chat) => {
                const users = chat.users || [];
                const connectedUser = chat.connectedUser;
                const agents = users.length ? users : connectedUser ? [connectedUser] : [null];
                agents.forEach((agent) => {
                    const group = chat.status === "chatbot" ? "chatbot" : agent || "unassign";
                    if (!acc[group]) {
                        acc[group] = {
                            id: group,
                            agent: agent,
                            items: [],
                        };
                    }
                    acc[group].items.push(_.cloneDeep(chat));
                });

                return acc;
            }, {});

            //sort each items by createdDate
            Object.keys(result).forEach((key) => {
                result[key].items = result[key].items.sort((a, b) => {
                    return new Date(a.createdDate) - new Date(b.createdDate);
                });

                let userIndex = this.usersOrdered.findIndex((user) => user._id === key);
                userIndex = key === "chatbot" ? 99999 : key === "unassign" ? 9999 : userIndex;
                result[key].order = key === this.user._id ? 0 : userIndex;
            });

            _.orderBy(result, "order").forEach((group) => {
                group.items.forEach((item) => {
                    item.index = index++;
                });
                group.indexStart = group.items[0]?.index;
                group.indexEnd = group.items[group.items.length - 1]?.index;
            });
            this.total = index;
            this.cache = result;
            this.cacheKey = cacheKey;
            if (this.initialized) {
                this.selectedIndex = this.findIndexByContactId(_.cloneDeep(result), this.activeContact?._id);
                this.first = false;
            }

            log("getGroups", result);
            return result;
        },
        agentName(agentId) {
            if (agentId === "chatbot") return "Chatbot";
            if (agentId === "unassign") return "Sahipsiz";
            return this.users[agentId]?.name || "-";
        },
        resetInterval() {
            if (this.dateInterval) clearInterval(this.dateInterval);
            this.dateInterval = null;
        },
        setupInterval() {
            this.resetInterval();
            this.dateInterval = setInterval(() => {
                this.dateRenderKey++;
            }, 1000);
        },
        isActive(contact) {
            return this.activeContact && this.activeContact._id === contact._id;
        },
        isAssignToMe(contact) {
            return contact.lastConversation.users.includes(this.user._id);
        },
        async select() {
            const groups = this.getGroups();
            const selected = Object.keys(groups)
                .map((x) => groups[x].items)
                .flat()
                .find((item) => item.index === this.selectedIndex);
            log("select " + selected?.visitor?.fullname, selected);
            if (selected) {
                const contactId = selected.visitor._id;
                let contact = this.contacts.find((x) => x._id === contactId);
                const inited = contact?.inited;
                if (!inited) contact = await this.getContactById({ contactId });
                if (!contact) {
                    this.$message.error(this.$t("chatWindow.noContactWasFoundMatchingTheCurrentFilters"));
                    return;
                }
                if (contact._id === this.activeContact?._id) {
                    this.close();
                    return;
                }

                const isAssignToMe = this.isAssignToMe(contact);
                if (this.watchingContactIds.length > 0) this.unWatchContactConversation(contact);
                if (isAssignToMe || this.isActive(contact)) {
                    log("toggleConversation", contact);
                    this.toggleConversation(contact);
                } else if (!this.isActive(contact)) {
                    log("watchContactConversation", contact);
                    this.watchContactConversation(contact);
                }
                this.close();
            }
        },
        selectWithIndex(index) {
            this.selectedIndex = index;
            this.select();
        },
        refresh(e) {
            if (e) e.stopPropagation();
            this.fetchChats(e);
            this.fetchOnlineUsers();
        },
    },
    mounted() {
        this.refresh(false);
        this.setupInterval();

        //keydown arrow right and left inc or dec selectedIndex
        //keydown up and down inc or dec selectedIndex
        const keydownHandler = (e) => {
            if (e.key === "ArrowRight") {
                this.selectedIndex = Math.min(this.selectedIndex + 1, this.total - 1);
            } else if (e.key === "ArrowLeft") {
                this.selectedIndex = Math.max(this.selectedIndex - 1, 0);
            }
            // press R to refresh
            else if (e.key === "r" || e.key === "R") {
                if (this.loading) return;
                this.refresh(false);
            }
            // press tab to jump to next group index
            else if (e.key === "Tab") {
                e.preventDefault();
                const groups = this.getGroups();
                const currentGroup = Object.keys(groups).find((key) =>
                    groups[key].items.some((item) => item.index === this.selectedIndex)
                );

                if (currentGroup) {
                    const turnStart = groups[currentGroup].indexEnd + 1 >= this.total;

                    this.selectedIndex = turnStart ? 0 : groups[currentGroup].indexEnd + 1;
                }
            }
            // press 1,2,3,...,9 button to switch selectedIndex
            else if (e.key >= "1" && e.key <= "9") {
                const index = parseInt(e.key) - 1;
                if (index < this.total) {
                    this.selectedIndex = index;
                    this.select();
                }
            }
            // press enter to select
            else if (e.key === "Enter") {
                this.select();
            }
        };
        window.addEventListener("keydown", keydownHandler);
        this.$once("hook:beforeDestroy", () => {
            window.removeEventListener("keydown", keydownHandler);
        });
    },
    beforeDestroy() {
        this.resetInterval();
    },
    watch: {
        selectedIndex() {
            const el = this.$el?.querySelector(`.customer-card[data-index="${this.selectedIndex}"]`);
            if (el) {
                el.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        },
    },
});
</script>

<style scoped lang="scss">
.contact-switch-screen {
    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
    }

    background-color: #fff;
    padding: 10px;
    position: fixed;
    overflow-y: auto;
    z-index: 2 !important;
    top: 104px;

    width: calc(100vw - 122px);
    height: calc(100vh - 104px);
    max-height: 91vh;

    .ant-divider-horizontal {
        margin: 10px 0;
    }

    .agent-filters {
        display: flex;
        gap: 5px;
        align-items: center;
        font-size: 20px;
    }

    .toolbar {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            font-size: 24px;
            font-weight: bold;
            //single-line text overflow ellipsis
            -webkit-line-clamp: 1;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .actions {
            display: flex;
            gap: 10px;

            .btn-refresh {
                display: flex;
                align-items: center;
                gap: 5px;

                .shortcut-keyboard {
                    font-size: 0.8rem;
                    font-weight: bold;
                    color: #000;
                    background-color: #f1f1f1;
                    padding: 2px 5px;
                    border-radius: 5px;
                    border: 1px solid #ccc;
                }
            }
        }
    }

    .summary {
        display: flex;
        padding: 10px;
        gap: 10px;
        border: 1px solid var(--color-border-default);
        box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);

        .item {
            flex: 1 1 25%;
            padding: 10px;
            //border: 1px solid var(--color-border-default);
            //box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
            margin-right: 10px;
            border-radius: 8px;
            display: flex;
            flex-direction: column;

            .key {
                font-weight: bold;
                font-size: 1.2rem;
                color: #000;
            }

            .value {
                font-size: 1.5rem;
                font-weight: bold;
                color: #000;
            }
        }
    }

    .groups {
        display: flex;
        flex-direction: column;

        .group {
            margin-bottom: 20px;
            border-bottom: 2px solid var(--color-border-default);

            .group-header {
                padding: 5px;
                margin-bottom: 5px;
                display: flex;
                gap: 10px;
                align-items: baseline;
                justify-content: flex-start;
                align-items: center;

                h2 {
                    font-size: 1.5rem;
                    margin-bottom: 10px;
                }

                .group-stats {
                    display: flex;
                    gap: 5px;
                    padding: 5px;
                    border: 1px solid var(--color-border-default);
                    box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
                    align-items: center;
                    line-height: 30px;

                    .group-stats-item {
                        display: flex;
                        gap: 5px;

                        &.total {
                            .key {
                                color: var(--color-text-info-default);
                            }
                        }

                        &.answered {
                            .key {
                                color: var(--color-text-success-default);
                            }
                        }

                        &.unanswered {
                            .key {
                                color: var(--color-text-warning-default);
                            }
                        }

                        .key {
                            font-weight: bold;
                        }

                        .value {
                            font-size: 14px;
                            font-weight: bold;
                            color: #666;
                        }
                    }
                }
            }

            .customers {
                display: flex;
                flex-wrap: wrap;
                gap: 5px;

                .customer-card {
                    flex: 1 1 25%;
                }
            }

            .customer-card {
                padding: 16px;
                margin-bottom: 10px;
                border-radius: 8px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: 110px;
                width: 250px;
                max-width: 250px;
                box-shadow: 0 0 10px 0 rgb(0 0 0 / 10%);
                position: relative;
                cursor: pointer;
                user-select: none;

                .index-shortcut-keyboard {
                    position: absolute;
                    top: 5px;
                    left: 5px;
                    font-size: 12px;
                    font-weight: bold;

                    padding: 2px 5px;
                    border-radius: 5px;
                    border: 1px solid #ccc;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: #000;
                    background-color: #f1f1f1;
                }

                &.selected {
                    border: 2px solid #000;
                }

                .customer-info {
                    display: flex;
                    flex-direction: column;
                    width: 100%;

                    .first-line {
                        display: flex;
                        align-items: center;
                        margin-bottom: 5px;

                        i {
                            font-size: 24px;
                            margin-right: 10px;
                        }

                        .texts {
                            display: flex;
                            flex-direction: column;
                        }
                    }

                    .customer-name {
                        font-weight: 600;
                        margin-bottom: 5px;
                    }

                    .customer-agent {
                        font-size: 14px;
                        color: rgb(110, 110, 119);
                        line-height: 20px;
                    }

                    .customer-agent,
                    .customer-duration {
                        display: flex;
                        align-items: center;
                        gap: 3px;
                        font-size: 0.9rem;
                        margin-bottom: 3px;
                    }

                    .metas {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                    }

                    .customer-status {
                        font-weight: bold;
                        padding: 4px 5px;
                        width: max-content;
                        border-radius: 9999px;

                        &.answered {
                            --tw-bg-opacity: 1;
                            background-color: rgb(220 252 231 / var(--tw-bg-opacity));
                            color: rgb(22 163 74 / var(--tw-text-opacity));
                        }

                        &.waiting {
                            --tw-bg-opacity: 1;
                            color: rgb(202 138 4 / var(--tw-text-opacity));
                            background-color: rgb(254 249 195 / var(--tw-bg-opacity));
                        }
                    }
                }
            }
        }
    }
}
</style>
